/**
 * Creative image formats. config/creative-formats.json owns the list; Python reads the
 * same file for the generation contract, and parity tests hold every other list to it.
 */
import creativeFormats from '../../../config/creative-formats.json';
import type { AssistantImageRequest } from './assistant-image-contracts.generated';

export type CreativeFormatId = NonNullable<AssistantImageRequest['selectedFormats']>[number];
export type CreativeImageSize = AssistantImageRequest['arguments']['size'];

export interface CreativeFormat {
  id: CreativeFormatId;
  name: string;
  ratio: string;
  renderSize: CreativeImageSize;
  deliveredSize: CreativeImageSize;
  platforms: Array<string>;
  placementIds: Array<string>;
  sources: Array<string>;
  checkedAt: string;
}

export const CREATIVE_FORMATS = creativeFormats.formats as ReadonlyArray<CreativeFormat>;
export const CREATIVE_FORMAT_IDS: ReadonlyArray<CreativeFormatId> = CREATIVE_FORMATS.map((format) => format.id);
export const CREATIVE_FORMAT_LIMITS = creativeFormats.limits;

export function creativeFormatById(id: unknown): CreativeFormat | null {
  return CREATIVE_FORMATS.find((format) => format.id === id) ?? null;
}

export function creativeFormatForSize(size: unknown): CreativeFormat | null {
  return CREATIVE_FORMATS.find((format) => format.renderSize === size) ?? null;
}
